export const DEFAULT_RESULTS_PAGE_SIZE = 500;
//# sourceMappingURL=paginateResults.js.map